import Vue from 'vue'
import Vuex from 'vuex'
import sepaMethods from './modules/sepaMethods'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        sepaMethods
    },
    state: {
        FlashColumnList:[],
        rfListOne: true,
        rfListTwo: true,
        rfListThree: true,
        resCondition: true,
        originMethods: true,
        flowPhaseList: [],
        MethodInfo: true,
        columnDetail: true,
        SampleInfo: false,
        flashColumn: false,
        sampleWeight: false,
        clickEluent: false,
        // clickFlowRate: false,
        clickGradient: false,
        clickSolvent: false,
        showEluent: false,
        // showFlowRate: false,
        showGradient: false,
        showSolvent: false,
        rows: {},
        supplierId: null,
        indexTrigger: '',
        userId: '',
        nickName: '',
        org: '',
        email: '',
        isLogin : false,
        tabs:[],
        serverName:'',
        serverDetail:'',
        tabsKey: '',
        infoForm: {},
        setting: {
            allowedOffShelves: false
        },
        list:{}

    },

    mutations: {
        updateFlashColumnList: function (state, value) {
            state.FlashColumnList = value;
        },
        RFListOne: function (state, value) {
            state.rfListOne = value;
        },
        RFListTwo: function (state, value) {
            state.rfListTwo = value;
        },
        RFListThree: function (state, value) {
            state.rfListThree = value;
        },
        updateResCondition: function (state, value) {
            state.resCondition = value;
        },
        updateMethodInfo: function (state, value) {
            state.MethodInfo = value;
        },
        updateOriginMethods: function (state, value) {
            state.originMethods = value;
        },
        updateColumnDetail: function (state, value) {
            state.columnDetail = value;
        },
        updateFlowPhaseList: function (state, value) {
            state.flowPhaseList = value;
        },
        updateSampleInfo: function (state, value) {
            state.SampleInfo = value;
        },
        updateFlashColumn: function (state, value) {
            state.flashColumn = value;
        },
        updateSampleWeight: function (state, value) {
            state.sampleWeight = value;
        },
        updateClickEluent: function (state, value) {
            state.clickEluent = value;
        },
        // updateClickFlowRate: function (state, value) {
        //     state.clickFlowRate = value;
        // },
        updateClickGradient: function (state, value) {
            state.clickGradient = value;
        },
        updateClickSolvent: function (state, value) {
            state.clickSolvent = value;
        },
        updateShowEluent: function (state, value) {
            state.showEluent = value;
        },
        // updateShowFlowRate: function (state, value) {
        //     state.showFlowRate = value;
        // },
        updateShowGradient: function (state, value) {
            state.showGradient = value;
        },
        updateShowSolvent: function (state, value) {
            state.showSolvent = value;
        },
        updateRows: function (state, value) {
            state.rows = value;
        },
        updateIsLogin: function (state, value) {
            state.isLogin = value;
        },
        updateSupplierId: function (state, value) {
            state.supplierId = value;
        },

        updateTabs(state, payload) {
            let tag = payload.tag;
            if (tag == 'add') {
                let tempTabs = state.tabs.filter(tab => tab.name === payload.tab.name);
                if (tempTabs.length == 0) {
                    // console.log('in add tabs');
                    state.tabsKey = payload.tab.name;
                    state.tabs.push(payload.tab);
                    state.indexTrigger = payload.tab.name;
                }else {
                    // console.log('in select tabs');
                    state.tabsKey = payload.tab.name;
                    state.indexTrigger = payload.tab.name;
                }

            }else if (tag == 'remove') {
                    let tabs = state.tabs;
                    let activeName = state.tabsKey;
                    if (activeName === payload.targetName) {
                        tabs.forEach((tab, index) => {
                            if (tab.name === payload.targetName) {
                                let nextTab = tabs[index + 1] || tabs[index - 1];
                                if (nextTab) {
                                    activeName = nextTab.name;
                                }
                            }
                        });
                    }
                    state.tabsKey = activeName;
                    state.indexTrigger = activeName;

                    state.tabs = tabs.filter(tab => tab.name !== payload.targetName);
                


            }
        },
        updateList: function(state, value){
              state.list = value;
        },
        updateTabsKey(state, key) {
            state.tabsKey = key;
            state.indexTrigger = key;
        },
        updateUserId(state, userId){
            state.userId = userId
        },
        updateNickName(state, nickName) {
            state.nickName = nickName;
        },
        updateInfoForm(state, form) {
            state.infoForm = form;
        },
        updateOrg(state, org) {
            state.org = org
        },
        updateEmail(state, email) {
            state.email = email
        },
        updateServerName(state,serverName){
            state.serverName=serverName
        },
        updateServerDetail(state,serverDetail){
            state.serverDetail=serverDetail
        },

        updateAllowedOffShelves(state, bool) {
            state.allowedOffShelves = bool;
        }

    }
})
